module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/banner/banner.component.scss
// module id = ./src/app/banner/banner.component.scss
// module chunks = main